import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import OverviewAttendanceAnalytics from "./routes/OverviewAttendanceAnalytics";
import ClassAttendanceAnalytics from "./routes/ClassAttendanceAnalytics";
import GradeAttendanceAnalytics from "./routes/GradeAttendanceAnalytics";
import StudentAttendanceAnalytics from "./routes/StudentAttendanceAnalytics";

export default store => {
  return {
    path: "attendance",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "attendance" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [
      OverviewAttendanceAnalytics(store),
      ClassAttendanceAnalytics(store),
      GradeAttendanceAnalytics(store),
      StudentAttendanceAnalytics(store),
    ],
  };
};
